import GoldenHourSection from './GoldenHourSection';

export default GoldenHourSection;
